<template>

    <div class="qclist">
        <big-img v-if="showImg" :img-src="imgSrc" @clickit="viewImg" />
        <div class="clearfix qcnav">
            <NavBar class="restclass" :title="title" left-text="返回" left-arrow @click-left="getBack" />
        </div>
        <div class="clientList">
            <Tabs v-model="activeName" style="padding: 0 0 2rem 0" @click="activetab">
                <Tab title="基本信息" name="a">
                    <Form v-model="form" @submit="onSubmit">
                        <van-field v-model="form.vehicleCode" :readonly="form.enumWorkOrderStatus != 1 ||
                            $route.query.type == '返修派工单'
                            " :required="true" autocomplete="off" :show-error="true" name="车辆编号" label="车辆编号"
                            placeholder="车辆编号" :rules="[{ required: true, message: '必填' }]" @keyup="queryvehicleCode"
                            @clear="clearvehicleCode" />
                        <van-popup v-model="showpicker" position="bottom" @close="closepopup">
                            <van-picker item-height="1.173rem" show-toolbar :columns="vehicleCodeColumn"
                                @cancel="showpicker = false" @confirm="onConfirm" />
                        </van-popup>
                        <!-- <van-field
                            v-model="form.barCode"
                            disabled
                            :show-error="true"
                            name="条码编号"
                            label="条码编号"
                            placeholder="条码编号" /> -->
                        <van-field v-model="form.barCode" :readonly="form.enumWorkOrderStatus != 1" clearable
                            autocomplete="off" icon="question-o" name="条码编号" label="条码编号" label-class="" :border="true"
                            maxlength="30" placeholder="输入条码编号" :show-error="true" :required="true"
                            :rules="[{ required: true, message: '必填' }]" bind:click-icon="onClickIcon"
                            @clear="clearbarCode" @keyup="querybarCode" />
                        <van-popup v-model="showbarCode" position="bottom">
                            <van-picker show-toolbar :columns="barCodeColumn" @cancel="showbarCode = false"
                                @confirm="barcodeConfirm" />
                        </van-popup>
                        <van-field v-model="form.category" disabled :show-error="true" name="车辆类别" label="车辆类别"
                            placeholder="车辆类别" />
                        <van-field v-model="form.model" disabled :show-error="true" name="车辆型号" label="车辆型号"
                            placeholder="车辆型号" />
                        <van-field v-model="form.brand" disabled :show-error="true" name="品牌" label="品牌"
                            placeholder="品牌" />
                        <!-- <van-field
                            v-model="form.username"
                            disabled
                            :show-error="true"
                            name="入场日期"
                            label="入场日期"
                            placeholder="入场日期" /> -->
                        <van-field v-model="form.customer" disabled :show-error="true" name="客户名称" label="客户名称"
                            placeholder="客户名称" />

                        <van-field v-model="form.owner" disabled :show-error="true" name="权责人" label="权责人"
                            placeholder="权责人" />
                        <van-field v-model="form.driversnamephone" clearable icon="question-o" autosize type="textarea"
                            label="驾驶员" :border="true" placeholder="输入驾驶员姓名电话" bind:click-icon="onClickIcon"
                            @keyup="queryDrivers" />
                        <van-popup v-model="showdrivers" :style="{ height: '30%' }" position="bottom">
                            <van-checkbox-group v-model="form.checkedDrivers">
                                <van-cell-group>
                                    <van-cell v-for="(item, index) in driversColumn" :key="item.id" clickable
                                        :title="item.driverNamePhone" @click="toggle(item, index)">
                                        <van-checkbox slot="right-icon" ref="checkboxes" shape="square"
                                            :name="item.driverNamePhone" />
                                    </van-cell>
                                </van-cell-group>
                            </van-checkbox-group>
                        </van-popup>
                        <div class="nextClass">
                            <Button round block type="info" native-type="submit" class="nextSpan">
                                下一步
                            </Button>
                        </div>
                    </Form>
                </Tab>
                <Tab title="维修信息" name="b" :disabled="tabdisabled">
                    <van-form @submit="onSubmits">
                        <div>
                            <van-panel>
                                <template #header>
                                    <van-cell title="报修信息">
                                        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                                        <template #right-icon>
                                            <!-- <van-icon name="search" style="line-height: inherit;" /> -->
                                            <!-- <van-tag type="danger" @click="routeto">原单据号</van-tag> -->
                                            <span v-if="
                                                form.enumWorkOrderType == 2 && title == '返修派工单'
                                            " class="button-text" @click="original">原单据号：{{ form.sourceNo }}</span>
                                        </template>
                                    </van-cell>
                                </template>
                                <van-field v-model="form.enumMaintenanceName" disabled :show-error="true" label="维修方式"
                                    placeholder="维修方式" />
                                <van-field v-model="form.faultDescription" rows="1" autosize label="故障描述"
                                    type="textarea" placeholder="故障描述" />
                                <el-row>
                                    <div class="imgAdd" style="padding: 0 0.213333rem">
                                        <span v-for="(item, index) in form.fileList" :key="index" class="itemImg">
                                            <img :src="item.url" alt="图片" class="uploadimg" @click="clickImg($event)">
                                        </span>
                                    </div>
                                    <el-col :span="12">
                                        <van-checkbox v-model="form.isOnlyRequisitionPart" shape="square"
                                            :disabled="form.enumWorkOrderStatus == 6 || form.enumWorkOrderType == 2 || pickuponlystats"
                                            @click="pickuponly">仅领件</van-checkbox>
                                    </el-col>
                                    <!-- <el-col :span="12">
                                        <van-checkbox
                                            v-if="form.enumWorkOrderStatus == 6"
                                            v-model="form.isNotMaintain"
                                            shape="square"
                                            :disabled="
                                                form.enumWorkOrderStatus == 6 ||
                                                    form.enumWorkOrderType == 2
                                            ">未维修</van-checkbox>
                                    </el-col> -->
                                </el-row>
                            </van-panel>
                            <van-panel>
                                <template #header>
                                    <van-cell title="维修项目">
                                        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                                        <template #right-icon>
                                            <!-- <van-icon name="search" style="line-height: inherit;" /> -->
                                            <van-tag v-if="
                                                $_has('maintain:maintainitemlist:view') &&
                                                title != '返修派工单'
                                            " style="margin-left: 10px" type="danger"
                                                @click="routetos">整车图片</van-tag>
                                            <van-tag v-if="
                                                $_has('maintain:maintainitemlist:view') &&
                                                title != '返修派工单'
                                            " style="margin-left: 10px" type="danger"
                                                @click="routeto">维修历史</van-tag>
                                        </template>
                                    </van-cell>
                                </template>
                                <van-cell v-for="(item, index) in form.items" v-if="form.items" :key="index" is-link
                                    @click="details(item, index)">
                                    <van-row>
                                        <div style="display: flex; justify-content: space-between">
                                            <div style="display: flex">
                                                <span style="
                            border-radius: 5px;
                            margin-left: 20px;
                            font-size: 10px;
                            margin-top: 3px;
                            width: 26px;
                            height: 26px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            background: #00cc99;
                          ">
                                                    {{ index + 1 }}
                                                </span>
                                                <span style="
                            font-size: 12px;
                            position: absolute;
                            left: 13vw;
                            top: -5px;
                            font-weight: 700;
                          ">维修类型：{{ item.maintenTypeName }}</span>
                                            </div>
                                            <span style="
                          color: #1890ff;
                          margin-right: 4vw;
                          font-size: 26px;
                          margin-top: -3px;
                        ">
                                                {{ item.maintainItemNum }}
                                            </span>
                                        </div>
                                        <div styel="margin-left:20px; height:2vh !important;">
                                            <span style="
                          font-size: 12px;
                          margin-left: 13vw;
                          font-weight: 700;
                        ">
                                                维修项目：{{ item.maintainItem }}
                                            </span>
                                        </div>
                                        <div style="height: 2vh !important">
                                            <span style="font-size: 12px; width: 25%; margin-left: 13vw">
                                                维修队：{{ item.teamName }}
                                            </span>
                                        </div>
                                        <div style="
                        border-bottom: 1px solid #ccc;
                        height: 5vh !important;
                      ">
                                            <span style="font-size: 12px; width: 25%; margin-left: 13vw">工位：{{
                                                item.stationName }}</span>
                                            <span style="font-size: 12px; width: 20%; margin-left: 10vw">
                                                {{ item.totalPrice }}元
                                            </span>
                                        </div>
                                        <p>
                                            <span style="width: 40%">{{ item.workerNames }}</span>
                                        </p>
                                    </van-row>
                                    <van-row>
                                        <div style="padding-left: 0vw; margin-top: 2vw">
                                            <div v-if="item.faultPhoto">
                                                <img v-for="(x, index) in item.faultPhoto.split(';')" :key="index"
                                                    style="width: 100px; height: 100px; margin-right: 5vw" :src="x"
                                                    alt="" @click.stop="clickImg($event)">
                                            </div>
                                            <div v-if="item.oldNewPhoto">
                                                <img v-for="(x, index) in item.oldNewPhoto.split(';')" :key="index"
                                                    style="width: 100px; height: 100px; margin-right: 5vw" :src="x"
                                                    alt="" @click.stop="clickImg($event)">
                                            </div>
                                            <div v-if="item.faultOver">
                                                <img v-for="(x, index) in item.faultOver.split(';')" :key="index"
                                                    style="width: 100px; height: 100px; margin-right: 5vw" :src="x"
                                                    alt="" @click.stop="clickImg($event)">
                                            </div>
                                        </div>
                                    </van-row>
                                    <van-cell v-if="form.items.length > 0" title="配件明细" />
                                    <el-table v-if="form.items.length > 0" :data="item.parts" border style="width: 100%"
                                        :header-cell-class-name="'tq-table-rom-header'" size="mini">
                                        <el-table-column label="序号" type="index" width="49" align="center" />
                                        <el-table-column v-if="$route.query.type == '返修结算单'" prop="isRework"
                                            show-overflow-tooltip label="是否返修">
                                            <template slot-scope="scope">
                                                <el-switch v-model="scope.row.isRework" :active-value="1"
                                                    :inactive-value="0"
                                                    @change="handleStatusChange(scope.row.isRework)" />
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="billStatusName" label="状态" width="50">
                                            <template slot-scope="scope">
                                                {{
                                                    scope.row.billStatusName
                                                        ? scope.row.billStatusName
                                                        : '正常'
                                                }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="customerBillNo" label="出库单号">
                                            <template slot-scope="scope">
                                                {{
                                                    scope.row.billStatusName == '缺件'
                                                        ? '-'
                                                        : scope.row.customerBillNo
                                                }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="part" label="配件名称" />
                                        <el-table-column prop="num" label="数量" width="50" />
                                        <el-table-column prop="unitPrice" label="单价">
                                            <template slot-scope="scope">
                                                {{
                                                    scope.row.billStatusName == '缺件'
                                                        ? '-'
                                                        : scope.row.unitPrice
                                                }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="totalPrice" label="合计金额">
                                            <template slot-scope="scope">
                                                {{
                                                    scope.row.billStatusName == '缺件'
                                                        ? '-'
                                                        : scope.row.totalPrice
                                                }}
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </van-cell>
                            </van-panel>
                            <van-cell v-if="
                                $route.query.type != '返修派工单' &&
                                title != '返修派工单' &&
                                form.enumWorkOrderStatus != 6 &&
                                !form.isOnlyRequisitionPart
                            " border title="添加维修项目" is-link @click="showLists" />
                        </div>
                        <div>
                            <van-popup v-model="showList" position="bottom" :style="{ height: '80%' }"
                                @click-overlay="closeshowList">
                                <!--<van-field
                                    v-model="maintainItemdetails.position"
                                    readonly
                                    :show-error="true"
                                    name="部位"
                                    label="部位"
                                    placeholder="部位"
                                    @click="title == '返修派工单' ? showpositions = false : showpositions = true" />
                                <van-popup
                                    v-model="showpositions"
                                    position="bottom">
                                    <van-picker
                                        item-height="1.173rem"
                                        show-toolbar
                                        :columns="positions"
                                        @cancel="showpositions = false"
                                        @confirm="confirmposition" />
                                </van-popup>
                                <van-field
                                    v-model="maintainItemdetails.part"
                                    readonly
                                    :show-error="true"
                                    name="部件"
                                    label="部件"
                                    placeholder="部件"
                                    @click="bwpart" />
                                <van-popup
                                    v-model="showpart"
                                    position="bottom">
                                    <van-picker
                                        item-height="1.173rem"
                                        show-toolbar
                                        :columns="parts"
                                        @cancel="showpart = false"
                                        @confirm="confirmpart" />
                                </van-popup> -->
                                <van-field v-model="maintainItemdetails.maintenTypeName" :readonly="projectreadonly"
                                    autocomplete="off" :required="true" :show-error="true"
                                    v-if='!form.isOnlyRequisitionPart' name="maintenTypeName" label="维修类型"
                                    :rules="[{ required: true, message: '必填' }]" placeholder="选择维修类型" @click="
                                        !projectreadonly
                                            ? (showmaintainItemse = true)
                                            : showmaintainItemse == false
                                        " @input="queryMaintainItem" />
                                <van-field v-model="maintainItemdetails.maintenTypeName" :readonly="projectreadonly"
                                    autocomplete="off" :required="true" v-if='form.isOnlyRequisitionPart'
                                    :show-error="true" name="maintenTypeName" label="维修类型"
                                    :rules="[{ required: true, message: '必填' }]" placeholder="选择维修类型"
                                    @input="queryMaintainItem" />
                                <van-popup v-if='!form.isOnlyRequisitionPart' v-model="showmaintainItemse"
                                    :style="{ height: '35%' }" position="bottom">
                                    <van-picker item-height="1.173rem" show-toolbar :columns="maintenTypes"
                                        @cancel="showmaintainItemse = false" @confirm="maintenTypeNamese" />
                                </van-popup>
                                <van-field v-model="maintainItemdetails.maintainItem" autocomplete="off"
                                    :show-error="true" name="maintainItem" label="维修项目" placeholder="选择项目"
                                    @click="showmaintainItems = true" @input="queryMaintainItem" />
                                <van-popup v-if='!form.isOnlyRequisitionPart' v-model="showmaintainItems"
                                    :style="{ height: '35%' }" position="bottom">
                                    <van-picker item-height="1.273rem" title-height='1.26rem' show-toolbar
                                        title='请输入维修项目' :columns="maintainItemslist" @cancel="showmaintainItems = false"
                                        @confirm="confirmmaintainItem" />
                                </van-popup>
                                <van-field v-model="maintainItemdetails.maintainType" autocomplete="off" readonly
                                    name="maintainType" label="项目分类" placeholder="自动带出" />
                                <!-- <van-field
                                    v-model="maintainItemdetails.maintainItemNum"
                                    autocomplete="off"
                                    :show-error="true"
                                    name="maintainItemNum"
                                    label="数量"
                                    placeholder="数量"
                                    @input="maintainItemdetails.maintainItemNum= checkNumberFloat(maintainItemdetails.maintainItemNum)" /> -->
                                <van-row>
                                    <van-col class="num">数量</van-col>
                                    <van-col>
                                        <van-stepper v-model="maintainItemdetails.maintainItemNum" class="num-stepper"
                                            min="1" max="99" integer />
                                    </van-col>
                                </van-row>
                                <van-field v-model="maintainItemdetails.workHour" autocomplete="off" :show-error="true"
                                    name="workHour" label="工时" placeholder="工时" @input="
                                        maintainItemdetails.workHour = checkNumberFloat(
                                            maintainItemdetails.workHour
                                        )
                                        " />
                                <!--:rules="[ { required: true, message: '必填' } ]"  -->
                                <van-field v-model="maintainItemdetails.unitPrice" autocomplete="off"
                                    :readonly="maintainItemdetails.maintainItemId != null" :show-error="true"
                                    name="unitPrice" label="工时单价" placeholder="工时单价" @input="
                                        maintainItemdetails.unitPrice = checkNumberFloat(
                                            maintainItemdetails.unitPrice
                                        )
                                        " />
                                <!-- :rules="[ { required: true, message: '必填' } ]" -->
                                <!-- <van-field
                                    v-model="maintainItemdetails.teamName"
                                    :required="true"
                                    :readonly="weixiugong"
                                    disabled
                                    v-if='addse==false'
                                    :show-error="true"
                                    name="维修队"
                                    label="维修队"
                                    placeholder="维修队"
                                    :rules="[ { required: true, message: '必填' } ]"
                                   /> -->
                                <!-- :rules="[ { required: true, message: '必填' } ]" -->
                                <van-field v-model="maintainItemdetails.teamName" :required="true"
                                    :readonly="weixiugong" disabled :show-error="true" name="维修队" label="维修队"
                                    placeholder="维修队" :rules="[{ required: true, message: '必填' }]"
                                    @click="teamlist" />
                                <van-popup v-model="showteam" position="bottom">
                                    <van-picker item-height="1.173rem" show-toolbar :columns="teamNames"
                                        @cancel="showteam = false" @confirm="confirmteam" />
                                </van-popup>
                                <van-row>
                                    <van-col :span="24">
                                        <van-field v-model="maintainItemdetails.stationName" :required="true"
                                            :readonly="weixiugong" :show-error="true" disabled
                                            v-if='!form.isOnlyRequisitionPart' autocomplete="off" label="工位"
                                            name="stationName" :border="true" placeholder="请输入"
                                            :rules="[{ required: true, message: '必填' }]" @click="worklist" />
                                        <van-field v-model="maintainItemdetails.stationName" :required="true"
                                            :readonly="weixiugong" :show-error="true" disabled
                                            v-if='form.isOnlyRequisitionPart' autocomplete="off" label="工位"
                                            name="stationName" :border="true"
                                            :rules="[{ required: true, message: '必填' }]" placeholder="请输入" />
                                        <van-popup v-if='!form.isOnlyRequisitionPart' v-model="showworkse"
                                            :style="{ height: '30%' }" position="bottom">
                                            <van-picker item-height="1.173rem" show-toolbar :columns="workerNamese"
                                                @cancel="showworkse = false" @confirm="worker" />
                                        </van-popup>
                                    </van-col>
                                </van-row>
                                <!-- </div> -->
                                <van-col :span="24">
                                    <van-field v-model="maintainItemdetails.remark" label="备注" name="remark"
                                        :readonly="form.isOnlyRequisitionPart" :border="true" placeholder="请输入" />
                                </van-col>
                                <van-field v-model="maintainItemdetails.enumFaultReasonname" readonly :required="true"
                                    :show-error="true" name="enumFaultReasonname" label="故障原因" placeholder="故障原因"
                                    :rules="[{ required: true, message: '必填' }]" @click="showenumFaultReasons" />
                                <van-popup v-model="showenumFaultReason" position="bottom">
                                    <van-picker item-height="1.173rem" show-toolbar :columns="enumFaultReasons"
                                        @cancel="showenumFaultReason = true" @confirm="confirmenumFaultReason" />
                                    <!-- 故障原因是否可编辑 -->
                                    <!-- @cancel="showenumFaultReason = false" -->

                                </van-popup>
                                <van-field v-model="maintainItemdetails.totalPrice" disabled :show-error="true"
                                    name="合计金额" label="合计金额" placeholder="合计金额" class="moneyColor" />
                                <div class="nextClass">
                                    <div class="container">
                                        <div class="Uploader">
                                            <div class="image">故障点照片</div>
                                            <div class="imgAdd">
                                                <div v-for="(item, index) in faultPhotoList" :key="index"
                                                    class="itemImg">
                                                    <img :src="item.url" alt="图片" class="uploadimg"
                                                        @click.stop="clickImg($event)">
                                                    <img src="../image/del.png" alt="" class="delte"
                                                        @click.stop="delImg('faultPhoto', 'faultPhotoList', index)">
                                                </div>
                                                <!-- <div>
                                                     <img
                                                        src="../image/del.png"
                                                        alt=""
                                                        class="delte"
                                                        @click.stop="delImg('faultPhoto', 'faultPhotoList')">
                                                </div> -->
                                                <div v-show="this.faultPhotoList.length < 3" class="fileupload-box">
                                                    <div class="c" @click="
                                                        photographs('faultPhoto', 'faultPhotoList')
                                                        ">
                                                        <img id="image" src="../image/1.png">

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <van-popup v-model="showworkses" :style="{ height: '30%' }" position="bottom">
                                        <van-picker item-height="1.173rem" show-toolbar
                                            :columns="[{ value: 0, text: '拍照', faultPhoto: 'faultPhoto', faultPhotoList: 'faultPhotoList' },
                                            { value: 1, text: '相册', faultPhoto: 'faultPhoto', faultPhotoList: 'faultPhotoList' }]" @cancel="showworkses = false"
                                            @confirm="photograph" />
                                    </van-popup>
                                    <div class="container">
                                        <div class="Uploader">
                                            <div class="image">新旧件对比</div>
                                            <div class="imgAdd">
                                                <span v-for="(item, index) in oldNewPhotoList" :key="index"
                                                    class="itemImg">
                                                    <img :src="item.url" alt="图片" class="uploadimg"
                                                        @click.stop="clickImg($event)">
                                                    <img src="../image/del.png" alt="" class="delte"
                                                        @click.stop="delImg('oldNewPhoto', 'oldNewPhotoList', index)">
                                                </span>
                                                <div v-show="this.oldNewPhotoList.length < 3" class="fileupload-box">
                                                    <div class="c" @click="
                                                        photographs('oldNewPhoto', 'oldNewPhotoList')
                                                        ">
                                                        <img id="image" src="../image/1.png">

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <van-popup v-model="oldandnew" :style="{ height: '30%' }" position="bottom">
                                        <van-picker item-height="1.173rem" show-toolbar
                                            :columns="[{ value: 0, text: '拍照', faultPhoto: 'oldNewPhoto', faultPhotoList: 'oldNewPhotoList' },
                                            { value: 1, text: '相册', faultPhoto: 'oldNewPhoto', faultPhotoList: 'oldNewPhotoList' }]" @cancel="oldandnew = false"
                                            @confirm="photograph" />
                                    </van-popup>
                                    <div class="container">
                                        <div class="Uploader">
                                            <div class="image">故障完成</div>
                                            <div class="imgAdd">
                                                <span v-for="(item, index) in faultOverList" :key="index"
                                                    class="itemImg">
                                                    <img :src="item.url" alt="图片" class="uploadimg"
                                                        @click.stop="clickImg($event)">
                                                    <img src="../image/del.png" alt="" class="delte"
                                                        @click.stop="delImg('faultOver', 'faultOverList', index)">
                                                </span>
                                                <div v-show="this.faultOverList.length < 3" class="fileupload-box">
                                                    <div class="c" @click="
                                                        photographs('faultOver', 'faultOverList')
                                                        ">
                                                        <img id="image" src="../image/1.png">

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <van-popup v-model="faultcompletion" :style="{ height: '30%' }" position="bottom">
                                        <van-picker item-height="1.173rem" show-toolbar :columns="[{ value: 0, text: '拍照', faultPhoto: 'faultOver', faultPhotoList: 'faultOverList' },
                                        { value: 1, text: '相册', faultPhoto: 'faultOver', faultPhotoList: 'faultOverList' }]"
                                            @cancel="faultcompletion = false" @confirm="photograph" />
                                    </van-popup>
                                    <Button v-if="!form.isOnlyRequisitionPart" round block type="info"
                                        native-type="submit" class="nextSpan">
                                        保存
                                    </Button>
                                </div>
                            </van-popup>
                        </div>
                    </van-form>

                    <van-row gutter="20" style="margin-top: 1rem; padding: 0 1rem">
                        <van-col v-if="
                            $_has('maintain:workorder:edit') &&
                            form.enumWorkOrderStatus == 1
                        " span="8">
                            <van-button round type="primary" block class="nextSpan" @click="zancun">暂存</van-button>
                        </van-col>
                        <van-col v-if="
                            $_has('maintain:workorder:close') &&
                            form.enumWorkOrderStatus != 6 &&
                            form.enumWorkOrderStatus != 7 &&
                            form.enumWorkOrderStatus != 1
                        " span="8">
                            <van-button class="nextSpan" round type="primary" block @click="close">关闭</van-button>
                        </van-col>
                        <van-col v-if="
                            $_has('maintain:workorder:edit') &&
                            form.enumWorkOrderStatus != 6 &&
                            form.enumWorkOrderStatus != 7
                        " span="8">
                            <van-button class="nextSpan" round type="primary" block @click="submit(1)">提交保存</van-button>
                        </van-col>
                        <van-col v-if="
                            $_has('maintain:workorder:edit') &&
                            form.enumWorkOrderStatus != 6 &&
                            form.enumWorkOrderStatus != 7 &&
                            !form.isOnlyRequisitionPart &&
                            form.repairCompleteTime == null
                        " span="8">
                            <van-button class="nextSpan" round type="primary" block @click="submit(2)">提交质检</van-button>
                        </van-col>
                    </van-row>
                </Tab>
            </Tabs>
        </div>
        <Repairpopup v-if="equiTimingRunVisible" ref="dalong" :visible.sync="equiTimingRunVisible" :modal-obj="modalObj"
            @getDetails="getDetails" />
        <el-dialog :close-on-click-modal="false" title="保养提醒/缺件到货提醒" :visible.sync="centerDialogVisible" width="80%">
            <p v-if="maintainStatus == 1">{{ maintainMessage }}</p>
            <br>
            <p v-if="maintenanceStatus == 1">上次维修缺件已到货是否进行继续维修</p>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="displaycancles">取消并不再提醒</el-button>
                <el-button size="mini" @click="centerDialogVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="displaymplists">确 定</el-button>
            </span>
        </el-dialog>
        <bottom />
    </div>

</template>

<script>
var moment = require('moment')
import { Button, Tab, Tabs, NavBar, Form, Toast, Dialog } from 'vant'
import bottom from '@/components/bottom'
import {
    getrepair,
    displayreminder,
    displayteam,
    GetworkerByMtId,
    WorkOrdertempSave,
    WorkOrdercommit,
    WorkOrdercommitQC,
    WorkOrdercommits,
    getWorkOrder,
    WorkOrderhistoryList,
    entrancequery,
    displaymplist,
    displaycancle,
    WorkOrderclose,
    StationWorkList
} from '@/api/maintain'
import {
    getvehicleCodeList,
    getCarDetails,
    getDriverList,
    getMaintenitemlistForDropdw,
    getDictionarySelect,
    getOdd,
    getbarCodeList,
    getvehicleInfoItem,
} from '@/api/basics'
import { mapGetters } from 'vuex'
import Repairpopup from '../components/repairpopup.vue'
import BigImg from '../components/bigImg.vue'
export default {
    name: 'DispatchList',
    components: {
        bottom,
        [Button.name]: Button,
        NavBar,
        Tab,
        Tabs,
        Form,
        Button,
        Repairpopup,
        BigImg,
        Dialog
    },
    data() {
        return {
            maintenTypeIdse: '',
            showImg: false,
            imgSrc: '',
            weixiugong: true,
            show: false,
            modalObj: {
                title: '维修历史',
                tableData: [],
                item: null
            },
            faultPhotoList: [],
            oldNewPhotoList: [],
            faultOverList: [],
            fileList: [],
            fileLists: [],
            photoList: '',
            photo: '',
            oldandnew: false,
            faultcompletion: false,
            centerDialogVisible: false,
            equiTimingRunVisible: false,
            showenumFaultReason: false,
            showwork: false,
            isTeams: false,
            showteam: false,
            showpart: false,
            showparts: false,
            showworkse: false,
            showpositions: false,
            showmaintainItems: false,
            showmaintainItemse: false,
            chosenContactId: null,
            editingContact: {},
            showList: false,
            showEdit: false,
            pickuponlystats: false,
            isEdit: false,
            projectreadonly: false,
            form: {
                entranceUrl: '',
                driverSign: null,
                dispatcherSign: null,
                oldnum: null,
                sheetNo: null,
                id: uuid(),
                enumWorkOrderType: 1,
                enumWorkOrderStatus: 1, // 单据状态
                vehicleCode: null, // 车辆编号
                barCode: null, // 条码编号
                category: null, // 车辆类别
                brand: null, // 品牌
                model: null, // 型号
                customer: null, // 客户名称
                phone: null, // 电话
                owner: null, // 权责人
                driver: null, // 驾驶员
                drivers: [], // 驾驶员电话+号码
                driverPhone: null, // 驾驶员电话
                entryTime: null, // 入场时间
                enumMaintenanceType: 1, // 维修类型
                faultDescription: null, // 故障描述
                items: [], // 维修项目
                checkedDrivers: [],
                enumMaintenanceName: '现场维修'
            },
            maintainItemdetails: {
                workOrderMen: [{ workerId: null, workerName: null, percent: null }],
                maintainItemNum: '',
                workHour: '',
                unitPrice: null,
                id: uuid(),
                partId: null,
                part: null,
                position: null,
                maintainItemId: null,
                maintenTypeId: null,
                faultPhoto: '',
                oldNewPhoto: '',
                faultOver: ''
            },
            maintainStatus: null,
            maintenanceStatus: null,
            tabdisabled: true,
            addse: true,
            title: '派工单',
            jbinfo: null,
            teamNames: [],
            parts: [],
            positions: [],
            maintainItemslist: [],
            num: null,
            driversColumn: [],
            showdrivers: false,
            showpicker: false,
            activeName: 'a',
            finishedText: '已加载全部',
            refreshing: false,
            loading: false,
            finished: false,
            showworkses: false,
            workers: [],
            vehicleCodeColumn: [],
            value1: 0,
            value2: '',
            enumFaultReasons: [
                { text: '自然损坏', value: 1 },
                { text: '驾驶操作', value: 2 },
                { text: '配件质量', value: 3 },
                { text: '维修装配', value: 4 }
            ],
            maintenTypes: [],
            workerNamese: [],
            option2: [],
            resData: [], // 克隆维修项目的原数据
            isSubmit: false, // 维修故障是否可编辑
            isTeam: false, // 维修队是否可改
            showbarCode: false, // 条码编号下拉框
            barCodeColumn: [] // 条码编号下拉框数据
        }
    },

    computed: {
        ...mapGetters(['companyId'])
    },
    watch: {
        $route: {
            handler: function (val, oldVal) {
                console.log(val, 'asdhjash')
                if (val.path == '/fxdispatchdetails') {
                    this.getDetails()
                }
                if (val.query.add && val.query.name != '整车') {
                    this.getOdd()
                }
            },
            // 深度观察监听
            deep: true
        },
        // $route(to) {
        //   alert(to.path)
        //   if (to.path=='') {
        //   }
        // },
        maintainStatus(val) {
            if (val == 1) {
                this.centerDialogVisible = true
            }
        },
        maintenanceStatus(val) {
            if (val == 1) {
                this.centerDialogVisible = true
            }
        },
        activeName(val) {
            console.log(val, this.$route.query.type)
            if (!this.$route.query.type || val == 'a') {
                this.tabdisabled = true
            }
            if (this.$route.query.add) {
                this.addse = true
            } else {
                this.addse = false
            }
            console.log(this.$route.query.add, this.addse, 'this.$route.query.add')
        },
        'maintainItemdetails.maintainItemNum'(val) {
            if (!val || val == 0) {
                this.maintainItemdetails.totalPrice = (
                    Number(this.maintainItemdetails.workHour) *
                    Number(this.maintainItemdetails.unitPrice)
                ).toFixed(2)
            } else {
                this.maintainItemdetails.totalPrice = (
                    Number(val) *
                    this.maintainItemdetails.workHour *
                    this.maintainItemdetails.unitPrice
                ).toFixed(2)
            }
        },
        'maintainItemdetails.workHour'(val) {
            if (!val || val == 0) {
                this.maintainItemdetails.totalPrice = 0
            } else if (
                !this.maintainItemdetails.maintainItemNum ||
                this.maintainItemdetails.maintainItemNum == 0
            ) {
                this.maintainItemdetails.totalPrice = (
                    Number(val) * this.maintainItemdetails.unitPrice
                ).toFixed(2)
            } else {
                console.log(this.maintainItemdetails.maintainItemNum)
                this.maintainItemdetails.totalPrice = (
                    this.maintainItemdetails.maintainItemNum *
                    Number(val) *
                    this.maintainItemdetails.unitPrice
                ).toFixed(2)
            }
        },
        'maintainItemdetails.unitPrice'(val) {
            if (!val || val == 0) {
                this.maintainItemdetails.totalPrice = 0
            } else if (
                !this.maintainItemdetails.maintainItemNum ||
                this.maintainItemdetails.maintainItemNum == 0
            ) {
                this.maintainItemdetails.totalPrice = (
                    Number(val) * this.maintainItemdetails.workHour
                ).toFixed(2)
            } else {
                console.log(this.maintainItemdetails.maintainItemNum)
                this.maintainItemdetails.totalPrice = (
                    this.maintainItemdetails.maintainItemNum *
                    Number(val) *
                    this.maintainItemdetails.workHour
                ).toFixed(2)
            }
        }
    },
    async mounted() {
        window['clicktotakephotos'] = (data) => {
            this.clicktotakephotos(data)
        }
        window['clicktotakephotoses'] = (data) => {
            this.clicktotakephotoses(data)
        }
        if (this.$route.query.type != '处理' && this.$route.query.name != '整车') {
            console.log('aaa')
            await this.getOdd()
        }
        await this.getDetails()
        // 检查人
        this.form.examinator = this.$store.state.user.userInfo.nickName
        this.form.examineTime = new Date()
        console.log(this.$route.query.add, 'this.$route.query.add')
        if (this.$route.query.add) {
            this.addse = true
        } else {
            this.addse = false
        }
    },
    async created() {
        // 维修部位
        await this.getDetails()
        console.log(this.$route.query.photos, '399')
        getDictionarySelect({ Code: 'Maintain:PositionsType' }).then((res) => {
            if (res.code === 200) {
                this.positions = res.data
                res.data.forEach((item) => {
                    item.text = item.name
                })
                this.positions = res.data
            }
        })
        // 获取维修类型
        getDictionarySelect({ Code: 'Maintain:MaintenceType' }).then((res) => {
            if (res.isSuccess) {
                console.log(res.data)
                this.maintenTypes = res.data
                this.maintenTypes.forEach((item) => {
                    item.text = item.name
                })
            }
        })
        // 获取维修项目
        getMaintenitemlistForDropdw({
            ModelIdStr: this.form.modelId,
            maintenTypeIds: this.maintainItemdetails.maintenTypeId
                ? [this.maintainItemdetails.maintenTypeId]
                : []
        }).then((res) => {
            res.data.pagerData.forEach((item) => {
                item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
            })
            this.maintainItemslist = res.data.pagerData
        })
        console.log('所有数据', this.form)
        console.log('页面跳转', this.form.modelId)
        console.log(this.$route.query.add, 'this.$route.query.add')
        if (this.$route.query.add) {
            this.addse = true
        } else {
            this.addse = false
        }
        // this.setParameters()
    },
    activated() {
        window['clicktotakephotos'] = (data) => {
            this.clicktotakephotos(data)
        }
        window['clicktotakephotoses'] = (data) => {
            this.clicktotakephotoses(data)
        }
        // this.setParameters()
        this.getDetails()
        this.showImg = false

    },
    methods: {
        clickImg(e) {
            this.showImg = true
            // 获取当前图片地址
            this.imgSrc = e.currentTarget.src
        },
        viewImg() {
            console.log(1111)
            this.showImg = false
        },
        pickuponly(val) {
            if (!this.pickuponlystats) {
                if (this.form.isOnlyRequisitionPart == true && this.form.items.length > 1) {
                    Dialog.confirm({
                        message: '表体维修项目有多行，确定后将变为一条'
                    })
                        .then(async () => {
                            this.form.items = []
                            this.form.items.push({
                                id: uuid(),
                                workOrderId: this.form.id,
                                maintainItemId: null,
                                maintenTypeId: null,
                                maintainItem: '仅领件',
                                stationId: null,
                                partId: null,
                                part: null,
                                position: null,
                                workHour: 0,
                                unitPrice: 0,
                                teamId: null,
                                teamName: '仅领件',
                                teamOrgNodeId: null,
                                totalPrice: null,
                                enumFaultReason: 1,
                                disabled: false,
                                billDetailList: [],
                                enumQualityInspectionResult: 1,
                                parts: [],
                                workOrderMen: [{ workerId: 1, workerName: '仅领件', percent: 100 }]
                            })
                        }).catch(() => {
                            this.form.isOnlyRequisitionPart = false
                        })
                } else if (this.form.isOnlyRequisitionPart == true) {
                    this.form.items = []
                    this.form.items.push({
                        id: uuid(),
                        workOrderId: this.form.id,
                        maintainItemId: null,
                        maintenTypeId: null,
                        maintainItem: '仅领件',
                        stationId: null,
                        partId: null,
                        part: null,
                        position: null,
                        workHour: 0,
                        unitPrice: 0,
                        teamId: null,
                        teamName: '仅领件',
                        teamOrgNodeId: null,
                        totalPrice: null,
                        enumFaultReason: 1,
                        disabled: false,
                        billDetailList: [],
                        enumQualityInspectionResult: 1,
                        parts: [],
                        workOrderMen: [{ workerId: 1, workerName: '仅领件', percent: 100 }]

                    })
                } else if (this.form.isOnlyRequisitionPart == false) {
                    this.form.items = []
                }
            }

        },
        original() {
            this.$router.push({
                path: '/dispatchList',
                query: { id: this.form.sourceId, type: '处理' }
            })
            // this.$route.query.type = '处理'
            // this.$route.query.id = this.form.sourceId
            this.getDetails()
        },
        // 路由跳转初始化
        async getDetails() {
            this.showList = false
            if (this.$route.query.type == '处理' && !this.$route.query.allCar) {
                this.cardisabled = true
                if (this.$route.query.activeName == 'b') {
                    this.activeName = 'b'
                } else {
                    this.activeName = 'a'
                }
                const res = await getWorkOrder(this.$route.query.id)
                console.log('获取详情', res.data.items)
                // for(var i=0;i<es.data.items.length;i++){
                //     if(res.data.items[i].maintenTypeName){
                //         this.maintenTypeNamese({
                //             id:'',
                //             name:''
                //         })
                //     }
                // }
                if (res.data.entranceUrl) {
                    res.data.fileList = []
                    // const picture = res.data.entranceUrl.split(';')
                    var picture = res.data.entranceUrl.split(';').filter(function (s) {
                        return s && s.trim() // 注：IE9(不包含IE9)以下的版本没有trim()方法
                    })
                    console.log(picture)
                    picture.forEach((item) => {
                        res.data.fileList.push({
                            url: item
                        })
                    })
                }
                this.resData = JSON.parse(JSON.stringify(res.data.items))
                if (res.data.items.length > 0) {
                    res.data.items.forEach((data, index) => {
                        data.teamNames = ''
                        data.status = true
                        data.index = index
                        if (data.workOrderMen.length > 0) {
                            data.workOrderMen.forEach((item) => {
                                data.workerNames = data.workOrderMen
                                    .map(function (obj) {
                                        return obj.workerName
                                    })
                                    .join(',')
                            })
                        }
                    })
                }
                this.form.vehicleCode = res.data.vehicleCode
                this.form.customerId = res.data.customerId
                await this.getHandList()
                console.log(this.driversColumn, res.data.drivers, '2323')

                if (this.driversColumn) {
                    this.driversColumn.forEach((element) => {
                        res.data.drivers.forEach((items) => {
                            if (element.driverNamePhone == items) {
                                element.checked = true
                            }
                        })
                    })
                }
                const arr = this.driversColumn.filter(function (obj) {
                    return obj.checked
                })
                res.data.driversnamephone = arr
                    .map(function (obj) {
                        return obj.driverNamePhone
                    })
                    .join(',')

                res.data.checkedDrivers = res.data.driversnamephone.split(',')
                res.data.enumMaintenanceType == 1
                    ? (res.data.enumMaintenanceName = '现场维修')
                    : (res.data.enumMaintenanceName = '场内维修')
                res.data.enumWorkOrderType == 2
                    ? (this.title = '返修派工单')
                    : (this.title = '派工单')
                // res.data.enumWorkOrderType == 2
                //   ? (this.projectreadonly = true)
                //   : (this.projectreadonly = false)
                if (this.$route.query.id && res.data.items.length > 0 && res.data.items[0].maintenTypeId) {
                    this.projectreadonly = true
                } else {
                    this.projectreadonly = false
                }
                this.form = res.data
                if (this.form.items.length > 0) {
                    for (var i = 0; i < this.form.items.length; i++) {
                        if (this.form.items[i].parts.length > 0) {
                            this.pickuponlystats = true
                        } else {
                            this.pickuponlystats = false
                        }
                    }
                }
                if (res.data.vehiclePicture) {
                    if (this.$route.query.photos) {
                        this.form.vehiclePicture = this.$route.query.photos
                    } else {
                        this.form.vehiclePicture = res.data.vehiclePicture
                    }
                }

                getMaintenitemlistForDropdw({
                    ModelIdStr: this.form.modelId,
                    maintenTypeIds: this.maintainItemdetails.maintenTypeId
                        ? [this.maintainItemdetails.maintenTypeId]
                        : []
                }).then((res) => {
                    res.data.pagerData.forEach((item) => {
                        item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
                    })
                    this.maintainItemslist = res.data.pagerData
                })
                console.log(this.form.driversnamephone, '1212')
            } else if (this.$route.query.type == '入场处理' && !this.$route.query.allCar) {
                entrancequery(this.$route.query.id).then(async (res) => {
                    this.form.customerId = res.data.customerId
                    this.form.enumMaintenanceName = '场内维修'
                    this.form.enumMaintenanceType = 2
                    this.form.enumWorkOrderStatus = 1
                    await this.getHandList()
                    this.driversColumn.forEach((element) => {
                        res.data.drivers &&
                            res.data.drivers.forEach((items) => {
                                if (element.driverNamePhone == items) {
                                    element.checked = true
                                }
                            })
                    })
                    const arr = this.driversColumn.filter(function (obj) {
                        return obj.checked
                    })
                    this.form.driversnamephone = arr
                        .map(function (obj) {
                            return obj.driverNamePhone
                        })
                        .join(',')
                    this.form.faultDescription = res.data.faultDescription
                    this.form.checkedDrivers = this.form.driversnamephone.split(',')
                    this.form.entranceId = res.data.id
                    this.form.modelId = res.data.modelId
                    this.form.category = res.data.category
                    this.form.barCode = res.data.barCode
                    this.form.owner = res.data.owner
                    this.form.vehicleCode = res.data.vehicleCode
                    this.form.customer = res.data.customer
                    this.form.brand = res.data.brand
                    this.form.model = res.data.model
                    this.form.drivers = res.data.drivers
                    this.form.entryTime = res.data.entryTime
                    this.form.driver = res.data.driverName
                    this.form.driverPhone = res.data.driverPhone
                    this.form.vehicleId = res.data.vehicleId
                    this.form.outStockType = res.data.outStockType
                    this.form.phone = null
                    this.chidisabled = true
                    getMaintenitemlistForDropdw({
                        ModelIdStr: this.form.modelId,
                        maintenTypeIds: this.maintainItemdetails.maintenTypeId
                            ? [this.maintainItemdetails.maintenTypeId]
                            : []
                    }).then((res) => {
                        res.data.pagerData.forEach((item) => {
                            item.text =
                                item.code + '-' + item.name + '-' + item.maintenTypeName
                        })
                        this.maintainItemslist = res.data.pagerData
                    })
                })
                this.displayreminders(this.form.vehicleId)
            } else if (this.$route.query.type == '返修派工单' && !this.$route.query.allCar) {
                this.title = this.$route.query.type
                this.projectreadonly = true
                getrepair(this.$route.query.id).then(async (res) => {
                    res.data.oldnum = res.data.sheetNo
                    res.data.enumMaintenanceType == 1
                        ? (res.data.enumMaintenanceName = '现场维修')
                        : (res.data.enumMaintenanceName = '场内维修')
                    this.activeName = 'a'
                    await this.getHandList()
                    console.log(this.driversColumn)
                    if (this.driversColumn) {
                        this.driversColumn.forEach((element) => {
                            res.data.drivers.forEach((items) => {
                                if (element.driverNamePhone == items) {
                                    element.checked = true
                                }
                            })
                        })
                    }
                    const arr = this.driversColumn.filter(function (obj) {
                        return obj.checked
                    })
                    res.data.driversnamephone = arr
                        .map(function (obj) {
                            return obj.driverNamePhone
                        })
                        .join(',')
                    res.data.checkedDrivers = res.data.driversnamephone.split(',')
                    this.form = res.data
                    this.form.enumWorkOrderStatus = 1
                    this.form.enumWorkOrderType = 2
                    this.form.items.forEach((item) => {
                        console.log(item)
                        item.enumFaultReason = 3 // item.enumFaultReason = null 解决bug-6871 ynn
                        item.disabled = true
                        item.id = uuid()
                        item.workOrderMen.forEach((ite) => {
                            ite.id = uuid()
                        })
                    })
                    this.form.id = uuid()
                    getMaintenitemlistForDropdw({
                        ModelIdStr: this.form.modelId,
                        maintenTypeIds: this.maintainItemdetails.maintenTypeId
                            ? [this.maintainItemdetails.maintenTypeId]
                            : []
                    }).then((res) => {
                        res.data.pagerData.forEach((item) => {
                            item.text =
                                item.code + '-' + item.name + '-' + item.maintenTypeName
                        })
                        this.maintainItemslist = res.data.pagerData
                    })
                })
            } else if (this.$route.query.add && !this.$route.query.allCar) {
                this.form = {
                    entranceUrl: '',
                    driverSign: null,
                    dispatcherSign: null,
                    oldnum: null,
                    sheetNo: null,
                    id: uuid(),

                    enumWorkOrderType: 1,
                    enumWorkOrderStatus: 1, // 单据状态
                    vehicleCode: null, // 车辆编号
                    barCode: null, // 条码编号details
                    category: null, // 车辆类别
                    brand: null, // 品牌
                    model: null, // 型号
                    customer: null, // 客户名称
                    phone: null, // 电话
                    owner: null, // 权责人
                    driver: null, // 驾驶员
                    drivers: [], // 驾驶员电话+号码
                    driverPhone: null, // 驾驶员电话
                    entryTime: null, // 入场时间
                    enumMaintenanceType: 1, // 维修类型
                    faultDescription: null, // 故障描述
                    items: [], // 维修项目
                    checkedDrivers: [],
                    enumMaintenanceName: '现场维修'
                }
                this.maintainItemdetails = {
                    workOrderMen: [{ workerId: null, workerName: null, percent: null }],
                    maintainItemNum: '',
                    workHour: '',
                    unitPrice: null,
                    id: uuid(),
                    partId: null,
                    part: null,
                    position: null,
                    maintainItemId: null,
                    maintenTypeId: null,
                    faultPhoto: '',
                    oldNewPhoto: '',
                    faultOver: ''
                }

                this.activeName = 'a'
            } else if (this.$route.query.allCar) {
                this.form.vehiclePicture = this.$route.query.photos
            }
        },
        // 取消保养提醒
        displaycancles() {
            const param = {
                maintainStatus: this.maintainStatus,
                maintenanceStatus: this.maintenanceStatus,
                vehicleId: this.form.vehicleId,
                vehicleCode: this.form.vehicleCode
            }
            displaycancle(param).then((res) => {
                if (res.isSuccess) {
                    this.$message({
                        message: res.message,
                        type: 'success'
                    })
                    this.centerDialogVisible = false
                }
            })
        },
        showenumFaultReasons() {
            if (this.title == '返修派工单') {
                this.enumFaultReasons = [
                    { text: '配件质量', value: 3 },
                    { text: '维修装配', value: 4 }
                ]
            } else {
                this.enumFaultReasons = [
                    { text: '自然损坏', value: 1 },
                    { text: '驾驶操作', value: 2 },
                    { text: '配件质量', value: 3 },
                    { text: '维修装配', value: 4 }
                ]
            }
            // this.isSubmit
            //   ? (this.showenumFaultReason = false)
            //   : (this.showenumFaultReason = true)
            this.isSubmit
                ? (this.showenumFaultReason = true)
                : (this.showenumFaultReason = true)
        },
        // 项目详情
        details(item, index) {
            if (this.form.items[index].maintainItem) {
                let maintainItems = this.form.items[index].maintainItem.split('-')
                if (maintainItems[2] != this.form.items[0].maintenTypeName) {
                    this.form.items[index].maintainItem = ''
                }
            }
            console.log(item, '项目详情')
            console.log(index, '项目详情')
            if (index == 0) {
                this.isTeams = true
            } else {
                this.isTeams = false
            }
            // if(this.$route.query.type=='处理'){
            //     if(index!=0){
            //         item.maintainItem=''
            //     }
            // }

            if (item.maintenTypeName) {
                this.maintenTypeNamese({
                    text: item.maintenTypeName,
                    name: item.maintenTypeName,
                    id: item.maintenTypeId
                })
            }
            if (index == 0) {
                this.projectreadonly = false
            } else {
                this.projectreadonly = true
            }
            this.indexs = index
            if (item.workOrderMen.length == 0) {
                item.workOrderMen = [
                    { workerId: null, workerName: null, percent: null }
                ]
            }
            this.maintainItemdetails = JSON.parse(JSON.stringify(item))
            if (item.faultOver) {
                //this.faultOverList = [{ url: item.faultOver }]
                let faultOvers = item.faultOver.split(';')
                faultOvers.forEach(x => {
                    this.faultOverList.push({ url: x })
                })
            }
            if (item.faultPhoto) {
                // this.faultPhotoList = [{ url: item.faultPhoto }]
                let faultPhotos = item.faultPhoto.split(';')
                faultPhotos.forEach(x => {
                    this.faultPhotoList.push({ url: x })
                })
            }
            if (item.oldNewPhoto) {
                //this.oldNewPhotoList = [{ url: item.oldNewPhoto }]
                let oldNewPhotos = item.oldNewPhoto.split(';')
                oldNewPhotos.forEach(x => {
                    this.oldNewPhotoList.push({ url: x })
                })
            }
            this.maintainItemdetails.enumFaultReasonname = this.convertStatus(
                this.maintainItemdetails.enumFaultReason
            )
            // stationName
            this.showList = true
            if (this.resData[index]) {
                item.status ? (this.isSubmit = true) : (this.isSubmit = false)
            } else {
                this.isSubmit = false
            }
            if (index == 0 && this.form.enumWorkOrderStatus === 1) {
                this.isTeam = false
            } else {
                this.isTeam = true
            }

        },
        activetab() {
            this.onSubmit()
        },
        // 工位档案列表
        worklist() {
            StationWorkList({
                StationCode: '',
                StationName: null,
                Status: null,
                CreatorName: '',
                StartDate: '',
                EndDate: '',
                status: 1,
                maintainId: this.maintainItemdetails.teamId,
                MaintainTypeId: this.maintenTypeIdse,
                PageIndex: 1,
                PageSize: 10000
            }).then((res) => {
                this.workerNamese = res.data.pagerData
                this.workerNamese.forEach((item) => {
                    item.text = item.workNum
                    item.texts = item.stationName
                })
                this.showworkse = true
                if (this.isTeam) {
                    this.showworkse = true
                    return
                }
                if (!this.isTeam) {
                    this.showworkse = true
                }
                if (this.form.items.length >= 1) {
                    this.showworkse = true
                } else {
                    this.showworkse = true
                }
            })
        },
        // 缺件确定
        displaymplists() {
            if (this.maintenanceStatus == 1) {
                displaymplist(this.form.vehicleId).then((res) => {
                    res.data.forEach((item) => {
                        if (item.workOrderMen.length == 0) {
                            item.workOrderMen = [
                                { workerId: null, workerName: null, percent: null }
                            ]
                        }
                    })
                    this.form.items = res.data
                    this.centerDialogVisible = false
                })
            } else {
                this.centerDialogVisible = false
            }
        },
        // 关闭派工单
        close() {
            Dialog.confirm({
                message: '是否关闭该派工单？'
            }).then(() => {
                WorkOrderclose(this.form.id).then((res) => {
                    if (res.isSuccess) {
                        Toast.success(res.message)
                        this.$router.push({ path: '/dispatching' })
                    }
                })
            })
        },
        // 点击删除
        delImg(what, whatList, index) {
            if (isNaN(index) || index >= this[`${whatList}`].length) {
                return false
            }
            console.log(this.photoList)
            // this.maintainItemdetails[`${what}`] = ''
            // this[`${whatList}`] = []

            this[`${whatList}`].splice(index, 1)
            if (this[`${whatList}`].length > 0) {
                this.maintainItemdetails[`${what}`] = ''
                this[`${whatList}`].forEach((item) => {
                    this.maintainItemdetails[`${what}`] = this.maintainItemdetails[`${what}`].concat(item.url + ';')
                })

                this.maintainItemdetails[`${what}`] = this.maintainItemdetails[`${what}`].slice(0, -1)
            } else {
                this.maintainItemdetails[`${what}`] = ''
            }

            return
        },
        // 点击的时候调用相机
        clicktotakephotos(val) {
            const obj = {
                url: process.env.VUE_APP_IMG + val
            }
            this[`${this.photoList}`].push(obj)
            if (this.maintainItemdetails[`${this.photo}`] != '' && this.maintainItemdetails[`${this.photo}`] != null) {
                this.maintainItemdetails[`${this.photo}`] = this.maintainItemdetails[`${this.photo}`] + ';' + process.env.VUE_APP_IMG + val
            } else {
                this.maintainItemdetails[`${this.photo}`] = process.env.VUE_APP_IMG + val
            }
        },
        // 点击的时候调用相机
        clicktotakephotoses(val) {
            const obj = {
                url: process.env.VUE_APP_IMG + val
            }
            this[`${this.photoList}`].push(obj)
            this.maintainItemdetails[`${this.photo}`] = process.env.VUE_APP_IMG + val
        },
        //拍照相册确认
        photograph(val) {
            if (val.value == 0) {
                this.photo = val.faultPhoto
                this.photoList = val.faultPhotoList
                const data = this.moment().format('YYYY-MM-DD HH:mm:ss')
                let gw = ''
                if (this.form.items.length > 0) {
                    gw = this.form.items[0].stationName
                }
                const code = this.form.vehicleCode
                const str = gw ? `${data},,${gw},,${code}` : `${data},,${code}`
                window.test.openCamera(str)
                if (val.faultPhoto == 'faultPhoto') {
                    this.showworkses = false
                } else if (val.faultPhoto == 'oldNewPhoto') {
                    this.oldandnew = false
                } else if (val.faultPhoto == 'faultOver') {
                    this.faultcompletion = false
                }
            } else {
                this.photo = val.faultPhoto
                this.photoList = val.faultPhotoList
                const data = this.moment().format('YYYY-MM-DD HH:mm:ss')
                let gw = ''
                if (this.form.items.length > 0) {
                    gw = this.form.items[0].stationName
                }
                const code = this.form.vehicleCode
                const str = gw ? `${data},,${gw},,${code}` : `${data},,${code}`
                window.test.openAlbum(str)
                if (val.faultPhoto == 'faultPhoto') {
                    this.showworkses = false
                } else if (val.faultPhoto == 'oldNewPhoto') {
                    this.oldandnew = false
                } else if (val.faultPhoto == 'faultOver') {
                    this.faultcompletion = false
                }
            }
        },

        //拍照相册确认
        photographs(faultPhoto, faultPhotoList) {
            this.photo = faultPhoto
            this.photoList = faultPhotoList
            const data = this.moment().format('YYYY-MM-DD HH:mm:ss')
            let gw = ''
            if (this.form.items.length > 0) {
                gw = this.form.items[0].stationName
            }
            const code = this.form.vehicleCode
            const str = gw ? `${data},,${gw},,${code}` : `${data},,${code}`
            window.test.openCamera(str)
            if (faultPhoto == 'faultPhoto') {
                this.showworkses = false
            } else if (faultPhoto == 'oldNewPhoto') {
                this.oldandnew = false
            } else if (faultPhoto == 'faultOver') {
                this.faultcompletion = false
            }
        },

        clicktotakephotose() {
            this.showworkses = true
        },
        oldandnews() {
            this.oldandnew = true
        },
        faultcompletions() {
            this.faultcompletion = true
        },
        // 提交
        submit(type) {
            if (!this.jbinfo) {
                Toast.fail('请检查必填项')
                return
            }
            if (this.form.items.length == 0) {
                Toast.fail('请添加维修项目数据')
                return
            }
            // console.log(11111,this.$route.query.type)
            if (
                !this.$route.query.type ||
                this.$route.query.type == '返修派工单' ||
                this.$route.query.type == '入场处理' || this.$route.query.add
            ) {
                this.form.sheetNo = this.sheetNos
                this.form.id = uuid()
            }
            this.form.items &&
                this.form.items.forEach((item) => {
                    item.workOrderMen = item.workOrderMen.filter((items) => {
                        return items.workerId
                    })
                })

            // console.log('提交信息', this.form)
            // return

            if (!this.form.examinator) {
                this.form.examinator = this.$store.state.user.userInfo.nickName
            }
            if (!this.form.examineTime) {
                this.form.examineTime = new Date()
            }
            console.log(this.form.examinator, this.form.examineTime, ' = new Date()')
            WorkOrdercommits(this.form).then((rese) => {
                console.log(rese)
                if (rese.code == 202) {
                    this.$dialog.confirm({
                        title: '提示',
                        message: rese.message
                    }).then(() => {
                        WorkOrdercommit(this.form).then((res) => {
                            if (res.code === 200) {

                                if (type == 2) {
                                    WorkOrdercommitQC(this.form).then((res) => {
                                        if (res.code === 200) {
                                            Toast.success(res.message)
                                            this.$router.push({ path: '/dispatching' })
                                        } else {
                                            this.$toast({
                                                message: res.message,
                                                duration: 2000,
                                                onClose: () => {
                                                    // Toast 关闭后重新加载
                                                    console.log('开始重新加载页面')
                                                    location.reload()
                                                }
                                            })
                                        }
                                    })
                                } else {
                                    Toast.success(res.message)
                                    this.$router.push({ path: '/dispatching' })
                                }

                            } else {
                                this.$toast(res.message)
                            }
                        })
                    }).catch(() => {

                    });

                } else {
                    WorkOrdercommit(this.form).then((res) => {
                        if (res.code === 200) {
                            if (type == 2) {
                                WorkOrdercommitQC(this.form).then((res) => {
                                    if (res.code === 200) {
                                        Toast.success(res.message)
                                        this.$router.push({ path: '/dispatching' })
                                    } else {
                                        this.$toast({
                                            message: res.message,
                                            duration: 2000,
                                            onClose: () => {
                                                // Toast 关闭后重新加载
                                                location.reload()
                                            }
                                        })
                                    }
                                })
                            } else {
                                Toast.success(res.message)
                                this.$router.push({ path: '/dispatching' })
                            }
                        } else {
                            this.$toast(res.message)
                        }
                    })
                }
            })

        },
        // 暂存
        zancun() {
            if (
                !this.$route.query.type ||
                this.$route.query.type == '返修派工单' ||
                this.$route.query.type == '入场处理'
            ) {
                this.form.sheetNo = this.sheetNos
                this.form.id = uuid()
            }
            WorkOrdertempSave(this.form).then((res) => {
                console.log(res)
                if (res.isSuccess) {
                    Toast(res.message)
                    this.$router.push({ path: '/dispatching' })
                }
            })
            console.log(this.form)
        },
        PrefixInteger(num, length) {
            return (Array(length).join('0') + num).slice(-length);
        },
        // 生成单号
        async getOdd() {
            this.sheetNos = 'PGHR202205230053'
            let tenantCode = null
            if (!this.$store.state.user.userInfo.tenantId) {
                tenantCode = '0000'
            } else {
                tenantCode = this.PrefixInteger(this.$store.state.user.userInfo.tenantId, 4)
            }
            var sheetNo = `PG${tenantCode
                }${moment().format('YYYY')}${moment().format('MM')}${moment().format(
                    'DD'
                )}`
            const res = await getOdd(sheetNo)
            if (res.isSuccess) {
                this.sheetNos = res.data.sheetNo
                console.log(res.data, '单号')
            }
        },
        // 维修队筛选
        async teamlist() {
            console.log(this.isTeams)
            if (this.isTeams) {
                this.showteam = true
            } else {
                this.showteam = false
            }

            //this.showteam = true
            const res = await displayteam(this.maintainItemdetails.maintainItemId)
            res.data.pagerData.forEach((item) => {
                item.text = item.teamName
            })
            this.teamNames = res.data.pagerData
        },
        // // 获取工时单价
        // setParameters() {
        //     setParameter({ OrgId: this.companyId }).then(res => {
        //         if (res.code === 200) {
        //             this.unitPrice = res.data.WorkHourPrice || 0
        //             this.maintainItemdetails.unitPrice = res.data.WorkHourPrice || 0
        //         }
        //     })
        // },
        // 部件列表
        // bwpart() {
        //     if (this.title == '返修派工单') {
        //         this.showpart = false
        //         return
        //     }
        // 部件列表
        // getVehiclepositList({ positionsName: [this.maintainItemdetails.position], partName: '', startTime: '', endTime: '', PageSize: 10000, PageIndex: 1, allData: 2 }).then(res => {
        //     if (res.data) {
        //         res.data.pagerData.forEach(item => {
        //             item.text = item.partName
        //         })
        //         this.parts = res.data.pagerData
        //         this.showpart = true
        //     } else {
        //         this.parts = []
        //         this.showpart = false
        //     }
        // })
        // },
        bwparts() { },
        // 确认故障原因
        confirmenumFaultReason(val) {
            console.log(val)
            this.enumFaultReasons.forEach((res) => {
                if (res.text == val.text) {
                    this.maintainItemdetails.enumFaultReason = res.value
                    this.maintainItemdetails.enumFaultReasonname = res.text
                    this.showenumFaultReason = false
                }
                // if(val.text)
            })

            if (
                (val.text == '配件质量' || val.text == '维修装配') &&
                this.title != '返修派工单'
            ) {
                this.equiTimingRunVisible = true
                // this.showList = false
                WorkOrderhistoryList({
                    vehicleId: this.form.vehicleId,
                    maintainItemId: this.maintainItemdetails.maintainItemId,
                    partId: null
                }).then((res) => {
                    this.modalObj.tableData = res.data
                })
            }
        },

        // 确认维修类型
        async maintenTypeNamese(val) {
            this.maintainItemdetails.maintainItem = ''
            this.form.items.forEach(item => {
                // item.maintainItem=''
            });
            // for(var i=0;i<this.form.items.length;i++){
            //     if(i==0){

            //     }else{
            //         this.form.items[i].maintainItem=''
            //     }
            // }
            console.log(val, 'jrr')
            this.maintenTypeIdse = val.code
            this.maintenTypes.forEach(async (res) => {
                if (res.id == val.id) {
                    this.maintainItemdetails.maintenTypeName = res.name
                    this.maintainItemdetails.maintenTypeId = res.code
                    this.showmaintainItemse = false
                    this.maintainItemdetails.factor = res.factor
                    this.maintainItemdetails.code = res.code
                }
            })
            const res = await getMaintenitemlistForDropdw({
                keywords: '',
                ModelIdStr: this.form.modelId,
                beginDate: '',
                endDate: '',
                maintenTypeIds: this.maintainItemdetails.maintenTypeId
                    ? [this.maintainItemdetails.maintenTypeId]
                    : [],
                PageSize: 20,
                PageIndex: 1
            })
            res.data.pagerData.forEach((item) => {
                item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
            })
            this.maintainItemslist = res.data.pagerData
        },
        // 维修队确认
        confirmteam(val) {
            this.maintainItemdetails.stationName = ''
            console.log('维修队', val, this.teamNames)
            this.teamNames.forEach((res) => {
                if (res.teamId == val.teamId) {
                    this.maintainItemdetails.teamName = res.teamName
                    this.maintainItemdetails.teamId = res.teamId
                    this.maintainItemdetails.workOrderMen.forEach((element) => {
                        element.workerId = null
                        element.workerName = null
                        element.percent = null
                    })
                    this.maintainItemdetails.teamOrgNodeId = res.orgNodeId
                    this.showteam = false
                }
            })
            this.form.items && this.form.items.forEach((item) => {
                item.workOrderMen && item.workOrderMen.forEach((workItem) => {
                    workItem.workerId = null
                    workItem.workerName = null
                    workItem.percent = null
                })
                item.teamOrgNodeId = this.form.items[0].teamOrgNodeId
                item.workerNames = null
            })
            console.log(this.form.items)
        },
        // 工位确认
        worker(val) {
            console.log(val)
            this.workerNamese.forEach((res) => {
                if (res.id == val.id) {
                    this.maintainItemdetails.stationId = res.id
                    this.maintainItemdetails.stationCode = res.stationCode
                    this.maintainItemdetails.stationName = res.texts
                    this.showworkse = false
                }
            })

            //this.showworkse = true
            // this.form.items&&this.form.items.forEach((item) => {
            //     // this.maintainItemdetails.stationName=this.form.items[0].stationName
            //     item.stationName = this.form.items[0].stationName
            // })
        },
        // 点击维修工加号
        addWorkOrder() {
            this.maintainItemdetails.workOrderMen.push({
                workerName: '',
                percent: '',
                deltBtn: '-'
            })
        },
        // 确认部位
        confirmposition(val) {
            this.maintainItemdetails.part = ''
            this.maintainItemdetails.partId = ''
            this.positions.forEach((res) => {
                if (res.id == val.id) {
                    this.maintainItemdetails.position = res.name

                    this.showpositions = false
                }
            })
        },
        // 点击减号删除
        deltWorkOrder(index) {
            this.maintainItemdetails.workOrderMen.splice(index, 1)
        },
        // 维修项目列表
        showLists() {
            if (this.form.items.length >= 1) {
                this.weixiugong = false
                this.showworkse = false
                this.showteam = false
                this.isTeams = false
            } else {
                this.isTeams = true
                this.indexs = 0
            }

            this.showList = true
            this.isSubmit = false
            console.log('是否有已提交的维修项目', this.form.items)
            this.maintainItemdetails.id = uuid()
            if (this.form.items.length > 0) {
                if (this.form.items[0] && this.form.items[0].maintenTypeId) {
                    this.projectreadonly = true
                } else {
                    this.projectreadonly = false
                }
                // maintenTypeName
                this.maintainItemdetails.teamName = this.form.items[0].teamName
                this.maintainItemdetails.teamId = this.form.items[0].teamId
                this.maintainItemdetails.maintenTypeName = this.form.items[0].maintenTypeName
                this.maintainItemdetails.maintenTypeId = this.form.items[0].maintenTypeId
                this.maintainItemdetails.stationName = this.form.items[0].stationName
                this.maintainItemdetails.stationId = this.form.items[0].stationId
                // this.maintainItemdetails.stationName = null
                // this.maintainItemdetails.stationId = null
                this.maintainItemdetails.teamOrgNodeId = this.form.items[0].teamOrgNodeId
                this.isTeam = true

            } else {
                this.isTeam = false
            }
        },
        // 清空车辆编号
        closepopup() {
            if (!this.num) {
                this.form.vehicleCode = null
            }
        },
        // 先选车辆才有驾驶员
        async showdriver() {
            if (!this.form.vehicleCode) {
                Toast('请先选择车辆')
            } else if (
                this.form.enumWorkOrderStatus != 1 ||
                this.title == '返修派工单'
            ) {
                return
            } else {
                // if (!this.form.driversnamephone) {
                //     await this.getHandList()
                // }
                if (this.driversColumn.length == 0) {
                    this.showdrivers = false
                } else {
                    this.showdrivers = true
                }
            }
        },
        // 选择驾驶员
        toggle(item, index) {
            console.log(this.driversColumn, index)
            if (item.checked == false) {
                console.log(this.$refs.checkboxes.length)
                item.checked = true
                this.$refs.checkboxes[index].toggle()
            } else {
                console.log(1111)
                item.checked = false
                this.$refs.checkboxes[index].toggle()
            }
            const arr = this.driversColumn.filter(function (obj) {
                return obj.checked
            })
            this.form.driversnamephone = arr
                .map(function (obj) {
                    return obj.driverNamePhone
                })
                .join(',')
            this.form.drivers = this.form.driversnamephone.split(',')
            console.log(this.driversColumn, '121212')
        },
        // 驾驶员下拉
        async getHandList() {
            if (!this.form.customerId) {
                this.driversColumn = []
                return
            }
            const param = {
                PageIndex: 1,
                PageSize: 10000,
                customerId: this.form.customerId
            }
            this.form.driver = null
            await getDriverList(param).then((res) => {
                if (res.isSuccess) {
                    res.data.pagerData.forEach((item) => {
                        item.driverNamePhone = item.name + '-' + item.contactNo
                        item.checked = false
                    })
                    this.driversColumn = res.data.pagerData
                }
            })
        },
        onConfirm(val) {
            this.num = val
            console.log(val, this.vehicleCodeColumn)
            const res = this.vehicleCodeList.filter((item) => {
                return item.code == val
            })
            this.form.outStockType = res[0].outStockType
            this.form.customerId = res[0].customerId

            getCarDetails(res[0].id).then(async (res) => {
                this.carid = val
                await this.getHandList()
                this.form.category = res.data.machineCategoryName
                this.form.barCode = res.data.barCode
                this.form.owner = res.data.ownerNames
                // if (res.data.vehicleDrivers) {
                //     res.data.vehicleDrivers.forEach(item => {
                //         item.driverNamePhone = item.driverName + '-' + item.driverPhone
                //         this.form.checkedDrivers.push(item.driverName + '-' + item.driverPhone)
                //     })
                //     this.form.driversnamephone = res.data.vehicleDrivers.map(function(obj) {
                //         return obj.driverNamePhone
                //     }).join(',')
                //     this.form.drivers = this.form.driversnamephone.split(',')
                //     this.driversColumn.forEach(element => {
                //         this.form.driversnamephone.split(',').forEach(items => {
                //             if (element.driverNamePhone == items) {
                //                 element.checked = true
                //             }
                //         })
                //     })
                // } else {
                //     this.form.checkedDrivers = []
                // }
                this.form.modelId = res.data.machineModelId
                this.form.machineModelId = res.data.machineModelId
                this.form.vehicleCode = res.data.code
                this.form.customer = res.data.customerName
                this.form.brand = res.data.machineBrandName
                this.form.model = res.data.machineModel
                // this.form.driver = res.data.driverName
                this.form.driverPhone = res.data.driverPhone
                this.form.vehicleId = res.data.id
                this.form.phone = null
                // if (!res.data.barCode) {
                //     this.$message({
                //         message: '请先维护该车辆档案的条码编号',
                //         type: 'error'
                //     })
                // }
                this.displayreminders(this.form.vehicleId)
                this.showpicker = false
            })
        },
        // 保养提醒
        displayreminders(vehicleId) {
            displayreminder(vehicleId).then((res) => {
                if (res.data) {
                    this.maintainStatus = res.data.maintainStatus
                    this.maintenanceStatus = res.data.maintenanceStatus
                    this.maintainMessage = res.data.maintainMessage
                }
            })
        },
        // 根据车辆变化查询
        queryvehicleCode() {
            //  Toast(1);
            // var data={};
            // data.code=this.vehicleCode;
            this.num = null
            this.vehicleCodeColumn = []
            var refData = []
            if (!this.form.vehicleCode) {
                return
            }
            getvehicleCodeList(this.form.vehicleCode).then((res) => {
                if (res.code == 200) {
                    this.vehicleCodeList = res.data
                    if (this.vehicleCodeList.length > 0) {
                        var i = 0
                        for (i; i < this.vehicleCodeList.length; i++) {
                            refData[i] = this.vehicleCodeList[i].code
                        }
                    }
                    this.vehicleCodeColumn = refData
                    this.showpicker = true
                    // Notify({ type: 'success', message: this.vehicleCodeList.length });
                } else {
                    Toast(res.message)
                }
            })
        },
        // 条码编号搜索
        querybarCode() {
            //  Toast(1);
            // var data={};
            // data.code=this.vehicleCode;
            this.barCodeColumn = []
            var refData = []

            getbarCodeList(this.form.barCode).then((res) => {
                if (res.code == 200) {
                    this.barCodeList = res.data
                    console.log(this.barCodeList)
                    if (this.barCodeList.length > 0) {
                        var i = 0
                        for (i; i < this.barCodeList.length; i++) {
                            refData[i] = this.barCodeList[i].barCode
                        }
                    }
                    this.barCodeColumn = refData
                    this.showbarCode = true
                    // Notify({ type: 'success', message: this.vehicleCodeList.length });
                } else {
                    Toast(res.message)
                }
            })
        },
        // 条码编号确认
        barcodeConfirm(val) {
            this.num = val
            console.log(val, this.barCodeColumn)
            const res = this.barCodeList.filter((item) => {
                return item.barCode == val
            })
            console.log(111111, res)
            this.form.outStockType = res[0].outStockType
            this.form.customerId = res[0].customerId

            getvehicleInfoItem(res[0].id).then(async (res) => {
                this.carid = val
                await this.getHandList()
                this.form.category = res.data.machineCategoryName
                this.form.barCode = res.data.barCode
                this.form.owner = res.data.ownerNames
                this.form.modelId = res.data.machineModelId
                this.form.machineModelId = res.data.machineModelId
                this.form.vehicleCode = res.data.code
                this.form.customer = res.data.customerName
                this.form.brand = res.data.machineBrandName
                this.form.model = res.data.machineModel
                // this.form.driver = res.data.driverName
                this.form.driverPhone = res.data.driverPhone
                this.form.vehicleId = res.data.id
                this.form.phone = null
                this.displayreminders(this.form.vehicleId)
                this.showbarCode = false
            })
        },
        clearbarCode() {
            console.log('clearvehicleCode')
            this.form.barCode = ''
        },
        clearvehicleCode() {
            console.log('clearvehicleCode')
            this.form.vehicleCode = ''
        },
        // 维修项目模糊搜索
        async queryMaintainItem() {
            this.maintainItemslist = []
            if (this.maintainItemdetails.maintainItem) {
                const res = await getMaintenitemlistForDropdw({
                    keywords: this.maintainItemdetails.maintainItem,
                    ModelIdStr: this.form.modelId,
                    beginDate: '',
                    endDate: '',
                    maintenTypeIds: this.maintainItemdetails.maintenTypeId
                        ? [this.maintainItemdetails.maintenTypeId]
                        : [],
                    PageSize: 20,
                    PageIndex: 1
                })
                res.data.pagerData.forEach((item) => {
                    item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
                })
                this.maintainItemslist = res.data.pagerData
            } else {
                const res = await getMaintenitemlistForDropdw({
                    keywords: '',
                    ModelIdStr: this.form.modelId,
                    beginDate: '',
                    endDate: '',
                    maintenTypeIds: this.maintainItemdetails.maintenTypeId
                        ? [this.maintainItemdetails.maintenTypeId]
                        : [],
                    PageSize: 20,
                    PageIndex: 1
                })
                res.data.pagerData.forEach((item) => {
                    item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
                })
                this.maintainItemslist = res.data.pagerData
            }
            if (this.maintainItemslist.length == 0) {
                this.maintainItemdetails.maintainItemId = null
                this.maintainItemdetails.workHour = null
                this.maintainItemdetails.unitPrice = null
                this.maintainItemdetails.maintainItemNum = null
            }
        },
        maintenTypeNames(val) {
            console.log(val, 'luyutong1')
        },

        // 确认维修项目
        confirmmaintainItem(val) {
            console.log(val)
            this.maintainItemdetails.maintainType = val.maintainType
            this.maintainItemslist.forEach(async (res) => {
                if (res.id == val.id) {
                    this.maintainItemdetails.enumMaintenType = res.enumMaintenType
                    this.maintainItemdetails.maintainItem =
                        res.code + '-' + res.name + '-' + res.maintenTypeName
                    this.maintainItemdetails.maintainItemId = res.id
                    this.maintainItemdetails.maintainType = res.maintainType
                    this.showmaintainItems = false
                    this.maintainItemdetails.workHour = res.hours
                    this.maintainItemdetails.unitPrice = res.price
                    // await getMaintenitemList({ maintenItemId: res.id, modelId: this.form.modelId || this.form.machineModelId }).then(res => {
                    //     if (res.data) {
                    //         this.maintainItemdetails.workHour = res.data.hours
                    //         this.maintainItemdetails.unitPrice = res.data.price
                    //     } else {
                    //         this.maintainItemdetails.workHour = null
                    //         this.maintainItemdetails.unitPrice = null
                    //     }
                    //     this.maintainItemdetails.maintainItemNum = null
                    // })
                }
            })
            // if (val) {
            //     this.projectreadonly = true
            //     // this.unitpricereadonly = true
            // } else {
            //     this.projectreadonly = false
            //     // this.unitpricereadonly = false
            // }
        },
        // 驾驶员下拉
        async queryDrivers() {
            console.log('客户id', this.form.customerId)
            if (this.form.enumWorkOrderStatus == 1) {
                this.showdrivers = true
            } else {
                this.showdrivers = false
                return
            }
            this.driversColumn = []
            if (!this.form.customerId) {
                this.driversColumn = []
                return
            }
            const param = {
                PageIndex: 1,
                PageSize: 10000,
                customerId: this.form.customerId,
                name: this.form.driversnamephone
            }
            this.form.driver = null
            const res = await getDriverList(param)
            if (res.isSuccess) {
                res.data.pagerData.forEach((item) => {
                    item.driverNamePhone = item.name + '-' + item.contactNo
                    item.checked = false
                })
                console.log('驾驶员', this.form.driversnamephone)
                this.driversColumn = res.data.pagerData
                if (this.driversColumn) {
                    this.driversColumn.forEach((element) => {
                        this.form.driversnamephone &&
                            this.form.driversnamephone.split(',').forEach((items) => {
                                if (element.driverNamePhone == items) {
                                    element.checked = true
                                }
                            })
                    })
                } else {
                    this.form.checkedDrivers = []
                }
            }
        },
        closeshowList() {
            (this.maintainItemdetails.faultPhoto = ''),
                (this.maintainItemdetails.faultOver = ''),
                (this.maintainItemdetails.oldNewPhoto = ''),
                (this.faultPhotoList = []),
                (this.faultOverList = []),
                (this.oldNewPhotoList = []),
                (this.maintainItemdetails.maintainItemNum = null)
            this.maintainItemdetails.workHour = null
            this.maintainItemdetails.position = null
            this.maintainItemdetails.part = null
            //this.maintainItemdetails.teamName = null
            this.maintainItemdetails.maintainItem = null
            this.maintainItemdetails.partId = null
            this.maintainItemdetails.maintainItemId = null
            this.maintainItemdetails.unitPrice = null
            this.maintainItemdetails.workerNames = null
            this.maintainItemdetails.workHour = null
            //this.maintainItemdetails.enumFaultReasonname = null
            //this.maintainItemdetails.enumFaultReason = null
            this.maintainItemdetails.totalPrice = 0
            this.maintainItemdetails.workOrderMen = [
                { workerId: null, workerName: null, percent: null }
            ]
            this.projectreadonly = false
        },
        onSubmits(val, index) {
            let isChangeTeam = true
            if (this.form.items.length > 1) {
                isChangeTeam = (this.maintainItemdetails.teamId == this.form.items[1].teamId)
            }
            if (!isChangeTeam) {
                Dialog.confirm({
                    title: '修改',
                    message: '修改维修队后，其余维修项目的维修队和工位都将修改。是否修改？',
                })
                    .then(() => {
                        this.update(val)
                    })
                    .catch(() => {

                    });
            } else {
                this.update(val)
            }
        },
        update(val) {
            if (val) {
                this.maintainItemdetails.pictures = this.fileLists
                this.maintainItemdetails.workOrderMen = this.maintainItemdetails.workOrderMen.filter((item) => {
                    return item.workerId
                })
                this.maintainItemdetails.workerNames = this.maintainItemdetails.workOrderMen.map(function (obj) {
                    return obj.workerName
                }).join(',')
                console.log(this.maintainItemdetails.id, 234923)
                console.log(val, '234923')
                let index = ''
                for (let i = 0; i < this.form.items.length; i++) {
                    if (this.maintainItemdetails.id == this.form.items[i].id) {
                        index = i
                    }
                }

                console.log('位置', index)
                if (this.form.items.findIndex((item) => item.id === this.maintainItemdetails.id) > -1) {
                    this.form.items.splice(this.form.items.findIndex((item) => item.id === this.maintainItemdetails.id), 1)
                    this.form.items.splice(index, 0, JSON.parse(JSON.stringify(this.maintainItemdetails)))
                } else {
                    this.form.items.push(JSON.parse(JSON.stringify(this.maintainItemdetails)))
                }

                this.maintainItemdetails.faultPhoto = null
                this.maintainItemdetails.oldNewPhoto = null
                this.maintainItemdetails.faultOver = null;
                (this.faultPhotoList = []), (this.oldNewPhotoList = [])
                this.faultOverList = []
                this.maintainItemdetails.maintainItemNum = null
                this.maintainItemdetails.workHour = null
                this.maintainItemdetails.position = null
                this.maintainItemdetails.part = null
                //this.maintainItemdetails.teamName = null
                this.maintainItemdetails.maintainItem = null
                this.maintainItemdetails.partId = null
                this.maintainItemdetails.maintainItemId = null
                this.maintainItemdetails.unitPrice = null
                this.maintainItemdetails.picture = ''
                this.maintainItemdetails.workHour = null
                this.maintainItemdetails.workerNames = null
                // this.maintainItemdetails.enumFaultReasonname = null
                // this.maintainItemdetails.enumFaultReason = null
                this.maintainItemdetails.totalPrice = 0
                this.maintainItemdetails.workOrderMen = [
                    { workerId: null, workerName: null, percent: null }
                ]
                this.showList = false
                console.log('保存后', this.form.items)
                console.log(index, 'indeinxini')

                this.form.items && this.form.items.forEach((item) => {
                    let isChangeTeam = (item.teamName == this.form.items[0].teamName)
                    item.teamName = this.form.items[0].teamName
                    item.teamId = this.form.items[0].teamId
                    item.teamOrgNodeId = this.form.items[0].teamOrgNodeId
                    console.log("isChangeTeam", isChangeTeam)
                    console.log("stationCode", item.stationCode)
                    if (!isChangeTeam) {
                        item.stationId = this.form.items[0].stationId  //工位第一条改变后其余所有工位改变
                        item.stationCode = this.form.items[0].stationCode
                        item.stationName = this.form.items[0].stationName
                    }
                    item.maintenTypeName = this.form.items[0].maintenTypeName
                    item.maintenTypeId = this.form.items[0].maintenTypeId

                })

            }
        },
        onSubmit(values) {
            console.log(values)
            if (values) {
                console.log(this.form)

                // if (!values['驾驶员']) {
                //     Toast.fail('请先维护车辆档案的驾驶员')
                //     return
                // }
                if (this.form.drivers && this.form.drivers.length > 2) {
                    Toast.fail('最多绑定两个驾驶员')
                    return
                }
                // if (!this.form.owner) {
                //     Toast.fail('请先维护车辆档案的权责人')
                //     return
                // }
                this.tabdisabled = false
                this.jbinfo = values
                this.$nextTick(() => {
                    this.activeName = 'b'
                })
            }
        },
        routeto() {
            this.$router.push({
                path: '/partsrepair',
                query: { keyword: this.form.barCode }
            })
        },
        routetos() {
            let gw = ''
            if (this.form.items.length > 0) {
                gw = this.form.items[0].stationName
            }
            this.$router.push({
                path: '/partsrepairs',
                query: {
                    id: this.form.id,
                    gw: gw,
                    vehicleCode: this.form.vehicleCode,
                    photos: this.form.vehiclePicture,
                    type: this.$route.query.type
                }
            })
        },
        getBack() {
            this.$router.push({ path: '/' })
            //   this.$router.back()
        },
        convertStatus(status) {
            switch (status) {
                case 1:
                    return '自然损坏'
                case 2:
                    return '驾驶操作'
                case 3:
                    return '配件质量'
                case 4:
                    return '维修装配'
            }
        }
    }
}
</script>

<style lang="scss">
.icon-style .van-icon {
    margin-top: 0.23rem;
}

.info-span-bottom {
    display: inline-block;
    padding: 0px 8px;
    color: #000;
    width: 46%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.van-picker__title {
    overflow: inherit !important;
}

.van-ellipsis {
    overflow: inherit !important;

}
</style>
